module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ee-Fb-Gc.422827b2.png";